<template>
  <div class="pb-fixed" :style="setPosition">
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbFixed",
  data: () => ({
    pos: {
      TOP_LEFT: "top: 3vh; left: 2vw",
      TOP_RIGHT: "top: 3vh; right: 2vw",
      TOP_CENTER: "top: 3vh; left: 50%; transform: translateX(-50%);",
      BOTTOM_LEFT: "bottom: 3vh; left: 2vw",
      BOTTOM_RIGHT: "bottom: 3vh; right: 2vw",
      BOTTOM_CENTER: "bottom: 3vh; left: 0; transform: translateX(-50%);"
    }
  }),
  props: {
    position: {
      type: String,
      default: () => "TOP_RIGHT"
    }
  },
  computed: {
    setPosition() {
      return this.pos[this.position];
    }
  },
  methods: {}
};
</script>
<style lang='scss'>
.pb-fixed {
  position: fixed;
}
</style>